//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { v4 as uuidv4 } from 'uuid';
import debounce from "lodash/debounce.js"
import isEmpty from "lodash/isEmpty.js"
import { string } from "mathjs";

export default {
  name: "TheSelect",
  props: {
    label: {
      type: String
    },
    placeholder: {
      type: String
    },
    iconTooltip: {
      type: String
    },
    value: {
      type: [Object, Array, String, Number]
    },
    selectedIcon: {
      type: String
    },
    searchFunction: {
      type: Function
    },
    multiple: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    staticOptions: {
      type: Array,
      default: () => {
        return []
      }
    },
    clearable: {
      type: Boolean,
      default: true
    },
    searchable: {
      type: Boolean,
      default: true
    },
    labelInValue: {
      type: Boolean,
      default: true
    },
    getOptionLabel: {
      type: Function,
      default: (option) => {
        if (typeof option === 'object') {
          if (!option.hasOwnProperty('label')) {
            return console.warn(
              `[vue-select warn]: Label key "option.${this.label}" does not` +
              ` exist in options object ${JSON.stringify(option)}.\n` +
              'https://vue-select.org/api/props.html#getoptionlabel'
            )
          }
          return option['label']
        }
        return option;
      }
    },
    size: {
      type: String,
      default: ''
    },
    filterable: {
      type: Boolean,
      default: false
    },
    appendToBody: {
      type: Boolean,
      default: false
    },
    calculatePosition: {
      type: Function,
      default(dropdownList, component, { width, top, left }) {
        dropdownList.style.top = top
        dropdownList.style.left = left
        dropdownList.style.width = width
      }
    },
    selectedOption: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      elementID: `select-${uuidv4()}`,
      options: [],
      search: '',
      observer: null,
      limit: 15,
      offset: 0,
      total: 0
    }
  },
  computed: {
    hasNextPage() {
      return this.total > this.options.length
    },
  },
  mounted() {
    this.observer = new IntersectionObserver(this.infiniteScroll)
    if (this.staticOptions.length) this.options = [...this.staticOptions]
    this.prefetchInitialOptions()
  },
  methods: {
    selectedIdsForSearch(explicitVal) {
      if (Array.isArray(explicitVal)) return explicitVal
      if (this.multiple && Array.isArray(this.value)) return this.value
      if (!this.multiple && !this.labelInValue && this.value != null && this.value !== '') {
        if (typeof this.value === 'number' || typeof this.value === 'string') return [this.value]
      }
      if (!this.multiple && this.labelInValue && this.value && typeof this.value === 'object' && this.value.id != null) {
        return [this.value]
      }
      return undefined
    },
    maybePrefetchOptionsForValue() {
      if (this.staticOptions.length || typeof this.searchFunction !== 'function') return
      const ids = this.selectedIdsForSearch()
      if (!Array.isArray(ids) || !ids.length) return
      const keyOf = (opt) => {
        if (typeof opt === 'string') return opt
        if (opt && typeof opt === 'object') return opt.id ?? opt.value
        return opt
      }
      const selectedKeys = ids.map((x) => (x && typeof x === 'object' ? keyOf(x) : x))
      const missing = selectedKeys.some((id) => !this.options.some((o) => String(keyOf(o)) === String(id)))
      if (missing) this.performSearch('', undefined, false)
    },
    prefetchInitialOptions() {
      this.maybePrefetchOptionsForValue()
    },
    async infiniteScroll([{ isIntersecting, target }]) {
      if (isIntersecting) {
        const ul = target.offsetParent
        const scrollTop = target.offsetParent.scrollTop
        this.offset += 15
        await this.performSearch(this.search, undefined, true)
        await this.$nextTick()
        ul.scrollTop = scrollTop
      }
    },
    onClose() {
      this.observer.disconnect()
      this.offset = 0
    },
    async onOpen() {
      await this.performSearch(this.search, undefined, false)
      await this.$nextTick()
      if (this.$refs.load) this.observer.observe(this.$refs.load)
    },
    async performSearch(search, loading, join = false, val = undefined) {
      if (this.staticOptions.length && typeof this.searchFunction !== 'function') return this.options = [...this.staticOptions]

      if (typeof loading === 'function') loading(true)
      let limit = Number(this.limit)
      const selectedIds = this.selectedIdsForSearch(val)
      // Чтобы запрос по ids не обрезался лимитом селекта (15), поднимаем limit хотя бы до числа выбранных
      if (Array.isArray(selectedIds) && selectedIds.length) {
        limit = Math.max(limit, selectedIds.length)
      }
      return this.searchFunction(search || "", limit, this.offset, selectedIds)
        .then(({ items, total }) => {
          if (join) {
            this.options.push(...items)
          } else {
            this.options = items
          }

          this.total = total
        })
        .catch(() => {
          this.total = 0
          this.options = []
        })
        .finally(() => {
          if (typeof loading === 'function') loading(false)
        })
    },
    searchCallback: debounce(function () {
      this.offset = 0
      this.performSearch(...arguments)
    }, 250),
    getOptionKey(option) {
      if (this.labelInValue || typeof option === 'string') return option
      return option.id || option.value
    }
  },
  watch: {
    staticOptions: function (val) {
      this.options = [...val]
    },
    value: {
      deep: true,
      handler() {
        this.maybePrefetchOptionsForValue()
      },
    },
  }
}
